
<div class="container-fluid p-0">
  <div class="authentication-main">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
        <div class="auth-innerright">
          <div class="authentication-box">
            <div class="card">
              <div class="card-header bg-info">
                <div class="text-center"><img src="../../../assets/images/logo/logo-inniver-small.png" alt=""></div>
              </div>
              <div class="card-body step-indicator bg-grey">
                <div class="text-center">
                  <h4>Register new user</h4>
                </div>

                  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                    <li [ngbNavItem]="1">
                      <a ngbNavLink>Account</a>
                      <ng-template ngbNavContent>

                        <form [formGroup]="accountForm" class="ngx-form" novalidate>
                          <div class="form-group">
                              <label class="control-label" for="username">Username</label>
                              <input type="text" formControlName="userName" class="form-control" placeholder="enter user name..">
                              <div *ngIf="accountForm.controls['userName'].invalid && (accountForm.controls['userName'].dirty || accountForm.controls['userName'].touched)"
                                  class="alert">
                                  <div *ngIf="accountForm.controls['userName'].errors?.['required']">
                                      User name is required.
                                  </div>
                              </div>
                          </div>
                          <div class="form-group">
                              <label class="control-label" for="firstname">First Name</label>
                              <input type="text" formControlName="firstName" class="form-control" placeholder="enter first name..">
                              <div *ngIf="accountForm.controls['firstName'].invalid && (accountForm.controls['firstName'].dirty || accountForm.controls['firstName'].touched)"
                                  class="alert">
                                  <div *ngIf="accountForm.controls['firstName'].errors?.['required']">
                                      First Name is required.
                                  </div>
                                  <div *ngIf="accountForm.controls['firstName'].errors?.['pattern']">
                                      Number is not allowed!
                                  </div>
                              </div>
                          </div>
                          <div class="form-group">
                              <label class="control-label" for="lastname">Last Name</label>
                              <input type="text" formControlName="lastName" class="form-control" placeholder="enter last name..">
                              <div *ngIf="accountForm.controls['lastName'].invalid && (accountForm.controls['lastName'].dirty || accountForm.controls['lastName'].touched)"
                                  class="alert">
                                  <div *ngIf="accountForm.controls['lastName'].errors?.['required']">
                                      Last Name is required.
                                  </div>
                                  <div *ngIf="accountForm.controls['lastName'].errors?.['pattern']">
                                      Number is not allowed!
                                  </div>
                              </div>
                          </div>
                          
                          <div class="form-group">
                              <label class="control-label" for="email">Email</label>
                              <input type="email" formControlName="emailAdd" class="form-control" autocomplete="off"
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [email]="true" required="required" placeholder="enter email..">
                              <div
                              *ngIf="accountForm.controls['emailAdd'].invalid && (accountForm.controls['emailAdd'].dirty || accountForm.controls['emailAdd'].touched)"
                              class="alert">
                              <div *ngIf="accountForm.controls['emailAdd'].errors?.['pattern']">
                                  Email is required and format should be <i>john@doe.com</i>
                              </div>
                              <div *ngIf="accountForm.controls['emailAdd'].errors?.['required'] ">Email is required.</div>
                              </div>
                          </div>
                      
                          <div class="form-group f1-buttons">
                              <button class="btn btn-pill btn-primary btn-next" [disabled]="!accountForm.valid" (click)="onClickNext()">Next
                              </button>
                              <!-- [disabled]="!accountForm.valid -->
                          </div>
                      </form>

                      </ng-template>
                    </li>

                    <li [ngbNavItem]="2" [disabled]=NavItemDisabled2>
                      <a ngbNavLink>Password</a>
                      <ng-template ngbNavContent>

                        <form [formGroup]="passwordForm" class="ngx-form" novalidate>
                          <div class="form-group">
                            <label class="control-label" for="f1-password">Password</label>
                            <input type="password" formControlName="password" class="form-control" autocomplete="off"
                              placeholder="enter password..">
                            <div
                              *ngIf="passwordForm.controls['password'].invalid && (passwordForm.controls['password'].dirty || passwordForm.controls['password'].touched)"
                              class="alert">
                              <div *ngIf="passwordForm.controls['password'].errors?.['required']">
                                Password is required.</div>
                              <div *ngIf="passwordForm.controls['password'].errors?.['minlength']">Password must be at least 8 characters</div>
                            </div>
                          </div>
                        
                          <div class="form-group">
                            <label class="control-label" for="f1-repeat-password">Repeat password</label>
                            <input type="password" formControlName="confirmPassword" class="form-control" autocomplete="off"
                              placeholder="repeat password ..">
                            <div
                              *ngIf="passwordForm.controls['confirmPassword'].invalid && (passwordForm.controls['confirmPassword'].dirty || passwordForm.controls['confirmPassword'].touched)"
                              class="alert">
                              <div *ngIf="passwordForm.controls['confirmPassword'].errors?.['required']">
                                Password is required.</div>
                              <div *ngIf="passwordForm.controls['confirmPassword'].errors?.['mustMatch']">
                                Password does not match
                              </div>
                            </div>
                          </div>
                          <div class="f1-buttons">
                            <button class="btn btn-pill btn-primary btn-previous" type="button" (click)="onClickPrevious()">Previous</button>
                            <button class="btn btn-pill btn-primary btn-next" type="button" (click)="onClickNext()" [disabled]="!passwordForm.valid">Next</button>
                            <!-- [disabled]="!emailForm.valid" -->
                          </div>
                        </form>

                      </ng-template>
                    </li>

                    <li [ngbNavItem]="3" [disabled]=NavItemDisabled3>
                      <a ngbNavLink>Address</a>
                      <ng-template ngbNavContent>

                        <form [formGroup]="addressForm" class="ngx-form" novalidate>                            
                        
                              <div class="form-group">                                
                                <label>Country</label>&nbsp;<i class="flag-icon flag-icon-{{flag | lowercase}}"></i>
                                <!-- <input type="text" formControlName="country" class="form-control" placeholder="Country.."> -->
                                <select id="country" class="form-control" formControlName="country" (change)="setFlag($event)">
                                  <option [ngValue]="null" selected disabled>country..</option>
                                  <option *ngFor="let country of countryData" value="{{country['id']}}">{{country['name']}}</option>
                                </select>
                                <div *ngIf="addressForm.controls['country'].invalid && (addressForm.controls['country'].dirty || addressForm.controls['country'].touched)"
                                  class="alert">
                                  <div *ngIf="addressForm.controls['country'].errors?.['required']">
                                    Country name is required.
                                  </div>
                                </div>
                              </div>
    

                              <div class="row">
                                <div class="col-md-8">
                                  <div class="form-group">
                                    <label>City</label>
                                    <input type="text" formControlName="cityName" class="form-control" placeholder="enter city..">
                                    <div *ngIf="addressForm.controls['cityName'].invalid && (addressForm.controls['cityName'].dirty || addressForm.controls['cityName'].touched)"
                                      class="alert">
                                      <div *ngIf="addressForm.controls['cityName'].errors?.['required']">
                                        City name is required.
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-4">
                                  <div class="form-group">
                                    <label>Zip/Postal code</label>
                                    <input type="text" formControlName="zip" class="form-control" placeholder="Zip/Postal..">
                                    <div *ngIf="addressForm.controls['zip'].invalid && (addressForm.controls['zip'].dirty || addressForm.controls['zip'].touched)"
                                      class="alert">
                                      <div *ngIf="addressForm.controls['zip'].errors?.['required']">
                                        Zip/Postal code number is required.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                          </div>
                       
                          <p>
                          <div class="form-group">
                            <label>Street</label>
                            <input type="text" formControlName="street" class="form-control" placeholder="enter street & number..">
                            <div *ngIf="addressForm.controls['street'].invalid && (addressForm.controls['street'].dirty || addressForm.controls['street'].touched)"
                              class="alert">
                              <div *ngIf="addressForm.controls['street'].errors?.['required']">
                                Street name and number is required.
                              </div>
                            </div>
                          </div>
                        
                        
                          <div class="f1-buttons">
                            <button class="btn btn-pill btn-primary btn-previous" type="button" (click)="onClickPrevious()">Previous</button>
                            <button class="btn btn-pill btn-primary btn-next" type="button" (click)="onClickNext()" [disabled]="!addressForm.valid">Next</button>
                            <!-- [disabled]="!addressForm.valid" -->
                          </div>
                        </form>

                      </ng-template>
                    </li>

                    <li [ngbNavItem]="4" [disabled]=NavItemDisabled4>
                      <a ngbNavLink>Registration</a>
                      <ng-template ngbNavContent>

                        <form [formGroup]="registerForm" class="ngx-form" novalidate>
                          <div class="form-group">
                            <label class="control-label" for="about">About</label>
                            <textarea rows="3" formControlName="about" class="form-control" placeholder="Write how you know about us and what is your experience in marketing. The information will be used for your verification.." ></textarea>
                            <div *ngIf="registerForm.controls['about'].invalid && (registerForm.controls['about'].dirty || registerForm.controls['about'].touched)"
                            class="alert">
                            <div *ngIf="registerForm.controls['about'].errors?.['required']">
                              Information is required.
                            </div>
                          </div>
                          </div>
                      
                          <div class="form-group">
                              <label class="control-label" for="Policy">Policy</label>
                              <div class="checkbox checkbox-solid-primary">
                                  <input id="solid3" type="checkbox" formControlName="policy" required>
                                  <label for="solid3">Agree to terms and conditions, I have read and agree with all the application policy regulations and will follow them</label>
                              </div>
                          </div>
                      
                          <div class="form-group f1-buttons">
                              <button class="btn btn-pill btn-primary btn-previous" type="button" (click)="onClickPrevious()">Previous</button>
                              <button class="btn btn-pill btn-primary btn-submit" type="submit" [disabled]="!registerForm.valid"
                                (click)="onRequest()">Submit
                              </button>
                          </div>
                      </form>

                      </ng-template>
                    </li>
                  </ul>

                  <div [ngbNavOutlet]="nav" class="mt-2"></div>
                  <!-- <div class="mt-3">
                    <button class="btn btn-sm btn-outline-primary" [disabled]="active3 === 4" (click)="nav.select(2)">Select second tab</button>
                  </div> -->

              </div>
            </div>

            <div class="text-center">Send me back to the <a class="btn-link"
              href="authentication/login">login page</a></div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
